import { ModalLayout } from '@starsoft/common/components';
import styles from './styles.module.scss';
import { ModalsKey } from '@/enums/modalsKey';
import useTranslation from 'next-translate/useTranslation';
import { useLottiePlayer, useModal } from '@starsoft/common/hooks';
import { ModalWithVersion } from '@/components/core/Modal/WithVersion';

export default function SessionsModal() {
  const { t } = useTranslation('common');
  const { isOpen } = useModal(ModalsKey.EndSession);

  const { lottieAnimationRef } = useLottiePlayer({
    path: `/end-session.json`,
    loop: false,
    dependecyArray: [isOpen],
  });

  return (
    <ModalWithVersion
      fitContent
      modal={ModalsKey.EndSession}
      title={t('end_session_title')}
    >
      <div className={styles.container}>
        <div className={styles.container__lottie} ref={lottieAnimationRef} />
        <div className={styles.container__title}>{t('end_session_title')}</div>
        <div className={styles.container__description}>
          {t('end_session_description')}
        </div>
      </div>
    </ModalWithVersion>
  );
}
